module.exports = __webpack_public_path__ + "img/carpetlogo.580bc025.png";